module.exports = __webpack_public_path__ + "img/5129.3abe6713.jpg";